import api from "../../../../../services/api";

// Catálogo global de opções de equipamento/serviço (roteamento, entrega final,
// entrega final cliente, serviceTypes, deliveryMedium), agrupado por `type` no backend.
// Extraído de circuito/index.js (etapa 19 do plano) — mesmas chamadas, sem mudança de payload.

export const createOpcaoCircuito = async ({ label, type }) => {
  const response = await api.post("/interno/create/opcaoCircuito", { label, type });
  return response?.data;
};

export const updateOpcaoCircuito = async ({ id, label }) => {
  const response = await api.post("/interno/update/opcaoCircuito", { id, label });
  return response?.data;
};

export const deleteOpcaoCircuito = async (id) => {
  const response = await api.post("/interno/delete/opcaoCircuito", { id });
  return response?.data;
};

export const findManyOpcaoCircuito = async () => {
  const response = await api.post("/interno/findMany/opcaoCircuito");
  return response?.data;
};
